"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var state = {
  regionData: {
    level_1: [],
    level_2: [],
    level_3: []
  },
  regionDataBySR: {
    level_sr: []
  }
};
var mutations = {
  SAVE_REGION_DATA: function SAVE_REGION_DATA(state, payload) {
    state.regionData[payload.key] = payload['regionData'];
  },
  SAVE_REGION_DATA_BY_SR: function SAVE_REGION_DATA_BY_SR(state, payload) {
    state.regionDataBySR = payload['regionData'];
  }
};
var actions = {
  saveRegionData: function saveRegionData(_ref, regionData) {
    var commit = _ref.commit;
    commit('SAVE_REGION_DATA', {
      key: 'level_3',
      regionData: regionData
    });
  },
  saveRegionDataByLevel: function saveRegionDataByLevel(_ref2, payload) {
    var commit = _ref2.commit;
    commit('SAVE_REGION_DATA', {
      key: payload.key,
      regionData: payload.regionData
    });
  },
  saveRegionDataBySR: function saveRegionDataBySR(_ref3, payload) {
    var commit = _ref3.commit;
    commit('SAVE_REGION_DATA_BY_SR', {
      key: payload.key,
      regionDataBySR: payload.regionData
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};